export default function NavCard() {
  return (
    <>
    
    </>
  );
}
